import { createFileRoute } from '@tanstack/react-router';

import { PerformanceAnalyzerPage } from '../features/reporting/performanceAnalyzer/components/PerformanceAnalyzerPage';
import { performanceAnalyzerRouteSearchSchema } from '../features/reporting/performanceAnalyzer/performanceAnalyzerRouteSearch';
import { usePerformanceAnalyzerRouteFilters } from '../features/reporting/performanceAnalyzer/usePerformanceAnalyzerRouteFilters';

export const Route = createFileRoute('/reporting/performance-analyzer')({
  validateSearch: performanceAnalyzerRouteSearchSchema,
  component: PerformanceAnalyzerRoute,
});

function PerformanceAnalyzerRoute() {
  const { primaryRange, setPrimaryRange } = usePerformanceAnalyzerRouteFilters();
  return (
    <PerformanceAnalyzerPage primaryRange={primaryRange} onPrimaryRangeChange={setPrimaryRange} />
  );
}
